document.addEventListener('DOMContentLoaded', () => {
  console.log('HH fabric filters JS loaded');

  const filterContainer = document.querySelector('.hh-fabric-filters');
  const cards = Array.from(document.querySelectorAll('.hh-fabric-card'));
  const checkboxes = Array.from(document.querySelectorAll('.hh-fabric-filters input[type="checkbox"]'));
  const clearButton = document.querySelector('.hh-fabric-filter-clear');
  const countEl = document.querySelector('[data-fabric-count]');

  const mobileToggle = document.querySelector('.hh-mobile-filter-toggle');
  const mobileFloat = document.querySelector('.hh-mobile-filter-float');

  const filterGroups = Array.from(document.querySelectorAll('.hh-fabric-filter-group'));

  const mobileClose = document.querySelector('.hh-mobile-filter-close');

  if (!filterContainer) return;

  // Top mobile "Filter Fabrics" button
  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      filterContainer.classList.toggle('is-open');

      mobileToggle.textContent = filterContainer.classList.contains('is-open')
        ? 'Hide Filters'
        : 'Filter Fabrics';
    });
  }

  // Floating "Change Filters" button
  if (mobileFloat && mobileToggle) {
    mobileFloat.addEventListener('click', () => {
      filterContainer.classList.add('is-open');
      mobileToggle.textContent = 'Hide Filters';
      mobileFloat.classList.remove('is-visible');

      mobileToggle.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    if (mobileClose) {
  mobileClose.addEventListener('click', () => {
    filterContainer.classList.remove('is-open');

    if (mobileToggle) {
      mobileToggle.textContent = 'Filter Fabrics';
      mobileToggle.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
}

    function updateMobileFilterFloat() {
      if (window.innerWidth > 989) {
        mobileFloat.classList.remove('is-visible');
        return;
      }

      const toggleBottom = mobileToggle.getBoundingClientRect().bottom;

      if (toggleBottom < 0) {
        mobileFloat.classList.add('is-visible');
      } else {
        mobileFloat.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', updateMobileFilterFloat);
    window.addEventListener('resize', updateMobileFilterFloat);
    updateMobileFilterFloat();
  }

  // Accordion behaviour: only one filter category open at a time
filterGroups.forEach((group) => {
  group.addEventListener('toggle', () => {
    if (!group.open) return;

    filterGroups.forEach((otherGroup) => {
      if (otherGroup !== group) {
        otherGroup.open = false;
      }
    });
  });
});

  if (!cards.length || !checkboxes.length) return;

  function getActiveFilters() {
    const filters = {};

    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) return;

      const group = checkbox.getAttribute('data-filter');
      const value = checkbox.value;

      if (!filters[group]) filters[group] = [];
      filters[group].push(value);
    });

    return filters;
  }

  function cardMatches(card, filters) {
    return Object.entries(filters).every(([group, selectedValues]) => {
      const cardValue = card.getAttribute(`data-${group}`) || '';
      const cardValues = cardValue.split(/\s+/).filter(Boolean);

      return selectedValues.some((selectedValue) => {
        return cardValues.includes(selectedValue);
      });
    });
  }

//   function updateFilterGroupLabels() {
//   filterGroups.forEach((group) => {
//     const summary = group.querySelector('summary');
//     const checked = Array.from(group.querySelectorAll('input[type="checkbox"]:checked'));

//     if (!summary) return;

//     const baseLabel = summary.getAttribute('data-base-label') || summary.textContent.trim();

//     if (!summary.getAttribute('data-base-label')) {
//       summary.setAttribute('data-base-label', baseLabel);
//     }

//     if (!checked.length) {
//       summary.textContent = baseLabel;
//       return;
//     }

//     const selectedLabels = checked.map((checkbox) => {
//       return checkbox.parentElement.textContent.trim();
//     });

//     summary.textContent = `${baseLabel} → ${selectedLabels.join(', ')}`;
//   });
// }

function updateFilterGroupChips() {
  filterGroups.forEach((group) => {
    const summary = group.querySelector('summary');
    const checked = Array.from(group.querySelectorAll('input[type="checkbox"]:checked'));

    if (!summary) return;

    let title = summary.querySelector('.hh-filter-title');
    let chips = summary.querySelector('.hh-filter-chips');

    if (!title) {
      const originalText = summary.childNodes[0]?.textContent.trim() || summary.textContent.trim();

      summary.innerHTML = '';

      title = document.createElement('span');
      title.className = 'hh-filter-title';
      title.textContent = originalText;

      chips = document.createElement('span');
      chips.className = 'hh-filter-chips';

      summary.appendChild(title);
      summary.appendChild(chips);
    }

    if (!chips) return;

    chips.innerHTML = '';

    checked.forEach((checkbox) => {
      const chip = document.createElement('span');
      chip.className = 'hh-filter-chip';
      chip.textContent = checkbox.parentElement.textContent.trim();
      chips.appendChild(chip);
    });
  });
}

function updateMobileFilterButtonText() {
  if (!mobileFloat) return;

  const activeCount = checkboxes.filter((checkbox) => checkbox.checked).length;

  mobileFloat.textContent = activeCount > 0
    ? `Change Filters (${activeCount})`
    : 'Change Filters';
}

  function updateFilters() {
    const filters = getActiveFilters();
    let visibleCount = 0;

    cards.forEach((card) => {
      const matches = cardMatches(card, filters);

      card.style.display = matches ? '' : 'none';

      if (matches) visibleCount += 1;
    });

    if (countEl) countEl.textContent = visibleCount;
    updateFilterGroupChips();
    updateMobileFilterButtonText();
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateFilters);
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      updateFilters();
    });
  }

  updateFilters();
});